import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brand } from '../../interfaces/Brand/Brand';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { DataTable } from '../../components/DataTable/DataTable';
import { paginateRows } from '../../utils/Pagination';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';

const columns: TableColumn<Brand>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'logo',
    name: 'Logo',
    accessor: (row) => <ImageColumn url={row.logo} />,
    align: 'center',
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'sort-order',
    name: 'Sıra',
    accessor: (row) => <TextColumn value={row.sortOrder.toString()} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'show-label',
    name: 'İsmi Göster',
    accessor: (row) => <BoolColumn value={row.showLabel} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type BrandsTableProps = {
  brands: Brand[];
};

export const BrandsTable = (props: BrandsTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.brands, limit, page),
    [props.brands, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.brands.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(brand) => navigate(`/products/brands/${brand.id}`)}
    />
  );
};
